<template>
  <div>
    <div class="timeline-detail no-expand" v-if="!isCartonFetchOpen">
      <span>
        <span>{{material.tag}}</span>
      </span>
      <span class="action-btn ml-auto" @click="openCartonAudit">
        <a href="javascript:void(0)" class="link-action">
          <svgicon name="icon-view" width="12" height="12" /> View
        </a>
      </span>
    </div>
    <div v-if="fetchOpen">
        <h4 class="pointer" @click="closeCartonAudit">
          <svgicon name="left_arrow" width="16" height="11" />
          {{ material.tag }}
        </h4>
        <Timeline class="timeline-default timestamp-left green-tail mt-20" style="max-height: 400px; overflow-y: auto">
          <TimelineItem placement="top" class="dot-green" v-for="(carton, index) in cartonAudit" :key="index" :name="index">
            <div class="el-timeline-item__timestamp is-top">
              <span class="date">{{ $moment(carton.date_time).format('MMM Do YY') }}</span>
              <span>{{ $moment(carton.date_time).format('LTS') }}</span>
            </div>
            <h4>{{ carton.details }}</h4>
            <p>{{ carton.performedBy }}</p>
          </TimelineItem>
        </Timeline>
      <infinite-loading @infinite="loadCartonAudit"  slot="append">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
      </div>
  </div>
</template>
<script>
export default {
  props: ['material', 'deliveryId', 'isCartonFetchOpen'],
  data() {
    return {
      fetchOpen: false,
      cartonAudit: [],
      page: 1,
    };
  },
  components: {},
  created() {},
  methods: {
    openCartonAudit() {
      this.$store.commit('order/SET_CARTON_FETCH', true);
      this.fetchOpen = true;
    },
    closeCartonAudit() {
      this.$store.commit('order/SET_CARTON_FETCH', false);
      this.fetchOpen = false;
    },
    async loadCartonAudit($state = null) {
      try {
        if (this.deliveryId && this.material) {
          const cartonAudit = await this.$store.dispatch('order/fetchCartonAudit', {
            delivery: this.deliveryId && this.deliveryId.id && this.deliveryId.id.toString(),
            carton_tag: this.material && this.material.tag,
            page: this.page,
          });
          if (cartonAudit && cartonAudit.length) {
            this.cartonAudit.push(...cartonAudit);
            this.page += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        } else {
          $state.complete();
        }
      } catch (error) {
        $state.complete();
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
  },
};
</script>
